import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useCustomTranslation } from "@plansoft-configuration-renderer/localization";
import { ConfigurationTabsContent } from "./ConfigurationTabsContent";
/**
 * Tab control on configuration level
 * @category UI
 * @param props
 * @returns
 */
export function ConfigurationTabs(props) {
    const { tabs } = props;
    const { t } = useCustomTranslation();
    const [activeTab, setActiveTab] = useState(0);
    const activeTabId = tabs[activeTab];
    return (_jsxs(Box, { sx: { my: "1em" }, children: [_jsx(Tabs, { orientation: props.orientation, onChange: (event, newValue) => setActiveTab(newValue), value: activeTab, children: tabs.map((tab, tabIndex) => (_jsx(Tab, { value: tabIndex, label: t(tab, tab) }, tabIndex))) }), props.showAllTabs ? (props.children) : (_jsx(ConfigurationTabsContent, { activeTab: activeTabId }))] }));
}
/**
 * Tab item for {@linkcode ConfigurationTabItem}
 * @category UI
 * @param props
 * @returns
 */
export function ConfigurationTabItem(props) {
    return _jsx(Fragment, { children: props.children });
}
//# sourceMappingURL=ConfigurationTabs.js.map